import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconTwitter = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="ultimate" colorKey="primary">
      <Path fill={`url(#gradient_${id})`} fillOpacity="0.9" d="M3.54105 4L10.054 12.7083L3.5 19.7885H4.97515L10.7133 13.5895L15.3494 19.7885H20.369L13.4895 10.5905L19.59 4H18.1148L12.8305 9.70897L8.56071 4H3.54105ZM5.71033 5.08648H8.01633L18.1995 18.702H15.8935L5.71033 5.08648Z"/>
    </IconWithGradient>);
};
